/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Resuming_TitleInputs */



/**
* | output |
* | --- |
* | "Approved — resuming shortly" |
*
* @param {Agent_Run_Resuming_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_resuming_title = /** @type {((inputs?: Agent_Run_Resuming_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Resuming_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Freigegeben, wird in Kürze fortgesetzt")
	return /** @type {LocalizedString} */ ("Approved — resuming shortly")
});